<template>
    <el-container class="is-vertical d-block-xs">
        <el-container class="relative column" v-loading="$store.state.libLoading">
            <div class="headings no-shrink" style="text-align:center;color:#fff">
                <div style="height: 50px" class="hidden-xs-only"></div>
                <h2>Asset library</h2>
            </div>
            <library-items v-if="myDemos.length" :items="myDemos" :is-asset="true"></library-items>
        </el-container>
    </el-container>
</template>

<script>
    import LibraryItems from "../components/library-items.vue"

    export default {
        name: 'MyLibrary',
        components: {
            LibraryItems
        },
        data() {
            return {
                isLoading: false,
                myDemos: []
            }
        },
        mounted: function () {
            this.$store.state.libLoading = true;
            console.log('mounted');
            this.axios.get(this.$store.state.API_URL + 'assetlib')
              .then((res) => {
                  this.myDemos = res.data.reverse();
                  this.$store.state.libLoading = false;
              });
        },
        methods: {
            deleteTour(tour) {
                this.myDemos.splice(this.myDemos.indexOf(tour), 1);
                setTimeout(() => {
                    this.$redrawVueMasonry();
                }, 100)
            },
            createNewTour() {
                let jwt = this.$store.state.env === "development" ? ("?jwt=" + localStorage.getItem("jwt")) : "";
                window.location.href = this.$store.state.API_URL + 'edit/new' + jwt;
                // this.axios.get(this.$store.state.API_URL + 'createNewDemo')
                //   .then((res) => {
                //     let jwt = this.$store.state.env === "development" ? ("?jwt=" + localStorage.getItem("jwt")) : "";
                //     window.location.href  = this.$store.state.API_URL + 'edit/' + res.data.id + jwt;
                //   });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/AssetLibrary.vue